import { render } from "./CategoriesPage.vue?vue&type=template&id=2b7f394b&ts=true"
import script from "./CategoriesPage.vue?vue&type=script&lang=ts"
export * from "./CategoriesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__